import { filter } from 'lodash';
import axios from '../../utils/axios-wrapper';
import { API_ORIGIN } from '../../config';

export default {
  get(id, config) {
    return axios
      .get(`${API_ORIGIN}/v2/processes${id ? `/${id}` : ''}`, config)
      .then((res) => res.data);
  },

  groupByType(processes) {
    return {
      additive: filter(processes, (proc) => proc.type === 'additive'),
      subtractive: filter(processes, (proc) => proc.type === 'subtractive'),
      extrusion: filter(processes, (proc) => proc.type === 'extrusion'),
      molding: filter(processes, (proc) => proc.type === 'molding'),
    };
  },

  getOutsourceableProcesses() {
    return axios
      .get(`${API_ORIGIN}/v2/processes?outsourceable=true`)
      .then((res) => res.data);
  },
};
